'use client';

import React from 'react';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';
import Image from 'next/image';

/**
 * Bežiaci pás výhod nad hlavičkou.
 *
 * Obsah ide z dynamickej sekcie 3 (Webstránky → Dynamické sekcie), fetch je
 * v serverovom `header/index.tsx` a sem chodí ako prop — komponent je klientsky
 * kvôli animácii, takže si dáta ťahať sám nemôže.
 *
 * Text položky je `name`, ikonka je `image` na položke. Poradie aj počet riadi
 * administrácia; kód nič nepredpokladá.
 */

// 4 copies so the track is always wider than any viewport.
// The keyframe moves -25% (= exactly one copy width), so the loop is seamless.
const COPIES = 4;

export function Topbar({ items }: { items?: TDynamicData[]; locale?: string }) {
  // Bez položiek nemá pás čo zobraziť — prázdny čierny prúžok by bol horší
  // než žiadny, tak sa nevykreslí vôbec.
  if (!items?.length) return null;

  return (
    <div className="relative z-40 w-full overflow-hidden">
      <div className="flex h-8 items-center bg-foreground sm:h-9 lg:h-10">
        <div
          className="flex shrink-0 items-center"
          style={{
            animation: 'topbar-marquee 28s linear infinite',
            willChange: 'transform',
          }}
        >
          {Array.from({ length: COPIES }, (_, copy) =>
            items.map((item, i) => (
              <React.Fragment key={`${copy}-${item.id ?? i}`}>
                <div
                  className="flex shrink-0 items-center gap-2 whitespace-nowrap px-3 text-sm font-bold text-white lg:text-base"
                  aria-hidden={copy > 0 ? true : undefined}
                >
                  {/* Ikonka je v administrácii nepovinná — bez nej ostane len text. */}
                  {!!item.image?.url && (
                    <Image
                      src={item.image.url}
                      alt=""
                      width={0}
                      height={0}
                      className="max-h-5 min-h-5 min-w-5 max-w-5 lg:max-h-6 lg:min-h-6 lg:min-w-6 lg:max-w-6"
                    />
                  )}
                  {item.name}
                </div>
                <div className="h-1.5 w-1.5 shrink-0 rounded-full bg-white" />
              </React.Fragment>
            )),
          )}
        </div>
      </div>
    </div>
  );
}
